import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'
import type { Player } from '@/types'

export const usePlayerStore = defineStore('player', () => {
  const players: Ref<Player[]> = ref([])
  const myPlayerId: Ref<string | null> = ref(null)
  const myPlayerName: Ref<string> = ref('')
  const isHost: Ref<boolean> = ref(false)
  const offerCode: Ref<string> = ref('')
  const connected: Ref<boolean> = ref(false)
  const roomId: Ref<string | null> = ref(null)

  const addPlayer = (player: Player): void => {
    if (!players.value.find(p => p.id === player.id)) {
      players.value.push(player)
    }
  }

  const removePlayer = (playerId: string): void => {
    players.value = players.value.filter(p => p.id !== playerId)
  }

  const updatePlayerScore = (playerId: string, score: number): void => {
    const player = players.value.find(p => p.id === playerId)
    if (player) {
      player.score = score
    }
  }

  const updateConnectionStatus = (playerId: string, status: import('@/types').ConnectionStatus): void => {
    const player = players.value.find(p => p.id === playerId)
    if (player) {
      player.connectionStatus = status
    }
  }

  const updatePlayerLatency = (playerId: string, latency: number): void => {
    const player = players.value.find(p => p.id === playerId)
    if (player) {
      player.latency = latency
    }
  }

  const syncPlayers = (playerList: Player[]): void => {
    players.value = playerList
  }

  const clearAllPlayers = (): void => {
    players.value = []
  }

  const setAsHost = (): void => {
    isHost.value = true
  }

  const setAsGuest = (): void => {
    isHost.value = false
  }

  const setMyPlayerId = (id: string): void => {
    myPlayerId.value = id
  }

  const setMyPlayerName = (name: string): void => {
    myPlayerName.value = name
  }

  const setOfferCode = (code: string): void => {
    offerCode.value = code
  }

  const setConnected = (value: boolean): void => {
    connected.value = value
  }

  const setRoomId = (id: string): void => {
    roomId.value = id
  }

  return {
    players,
    myPlayerId,
    myPlayerName,
    isHost,
    offerCode,
    connected,
    roomId,
    addPlayer,
    removePlayer,
    updatePlayerScore,
    updateConnectionStatus,
    updatePlayerLatency,
    syncPlayers,
    clearAllPlayers,
    setAsHost,
    setAsGuest,
    setMyPlayerId,
    setMyPlayerName,
    setOfferCode,
    setConnected,
    setRoomId
  }
})
